function setDayIndex(date, dayIndex) {
    var diff = dayIndex - date.getDay();
    date.setDate(date.getDate() + diff);
}
export function renderDayName(locale, dayIndex) {
    var tempDate = new Date();
    setDayIndex(tempDate, dayIndex);
    return tempDate.toLocaleDateString(locale, { weekday: 'short' });
}
export function renderMonthAndYear(locale, baseDate) {
    var result = baseDate.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long'
    });
    return result;
}
export function renderDayLabel(locale, date) {
    return date.toLocaleDateString(locale, {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
    });
}
//# sourceMappingURL=intl.js.map